import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { CheckCircle2, XCircle } from "lucide-react";

const Entry = ({ e, i }) => (
  <div className="py-2 border-b border-border last:border-0" data-testid={`send-log-entry-${i}`}>
    <div className="text-xs font-medium">{e.kind} · {new Date(e.at).toLocaleString("fr-FR")}{e.rib ? " · RIB joint" : ""}</div>
    {(e.to || []).map((r) => (
      <div key={`ok-${r}`} className="flex items-center gap-1.5 text-xs text-emerald-700"><CheckCircle2 className="w-3.5 h-3.5" />{r}</div>
    ))}
    {(e.failed || []).map((r) => (
      <div key={`ko-${r}`} className="flex items-center gap-1.5 text-xs text-destructive"><XCircle className="w-3.5 h-3.5" />{r} — {e.reason ? `non envoyé : ${e.reason}` : "échec de l'envoi"}</div>
    ))}
    {!(e.to || []).length && !(e.failed || []).length && e.reason && <div className="text-xs text-destructive">Non envoyé : {e.reason}</div>}
    {e.note && <div className="text-xs" data-testid={`send-log-note-${i}`}>{e.note}{e.by ? ` (par ${e.by})` : ""}</div>}
    {!(e.to || []).length && !(e.failed || []).length && !e.reason && !e.note && <div className="text-xs text-muted-foreground">Destinataires non enregistrés</div>}
  </div>
);

export const SendLog = ({ log, number }) => {
  const s = log[log.length - 1];
  const ko = (s.failed || []).length;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" data-testid={`send-log-${number}`}
          className="text-[11px] text-foreground/70 mt-0.5 whitespace-nowrap underline decoration-dotted underline-offset-2 hover:text-foreground transition-colors">
          {s.kind} le {new Date(s.at).toLocaleDateString("fr-FR")} · {(s.to || []).length} envoyé(s)
          {ko > 0 && <span className="text-destructive font-medium"> · {ko} échec(s)</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-80 max-h-80 overflow-auto" data-testid={`send-log-popover-${number}`}>
        <div className="text-xs font-semibold">Historique des envois</div>
        <div className="text-[10px] text-muted-foreground mb-1">« Envoyé » = accepté par le serveur d'emails. Si le destinataire ne le voit pas, faites vérifier ses courriers indésirables.</div>
        {[...log].reverse().map((e, i) => <Entry key={e.at + i} e={e} i={i} />)}
      </PopoverContent>
    </Popover>
  );
};
